export default __webpack_public_path__ + "static/media/clock.e3774978.png";